var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1111 9.375V2.08333C24.1111 1.53079 23.9296 1.0009 23.6067 0.610188C23.2838 0.2195 22.8456 0 22.3889 0H1.72222C1.26545 0 0.827407 0.2195 0.504422 0.610188C0.181453 1.0009 0 1.53079 0 2.08333V22.9167C0 23.4692 0.181453 23.9992 0.504422 24.3898C0.827407 24.7804 1.26545 25 1.72222 25H22.3889C22.8456 25 23.2838 24.7804 23.6067 24.3898C23.9296 23.9992 24.1111 23.4692 24.1111 22.9167V15.625L31 23.9583V1.04167L24.1111 9.375ZM8.61111 18.75V6.25L16.3611 12.5L8.61111 18.75Z",
    fill: "#052921"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconLarge);
export default __webpack_public_path__ + "static/media/video_icon_large.79c279b5c064da55c5931c7f6ef9189b.svg";
export { ForwardRef as ReactComponent };